<template>
<div id="app">
  <v-app id="inspire">
    <v-card>
      <v-card-title>
        Nutrition
        <v-spacer></v-spacer>
        <div>
          <v-select v-model="selectedHeaders" :items="headers" label="Select Columns" multiple outlined return-object>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} others)</span>
            </template>
         </v-select>
        </div>
      </v-card-title>
      <v-data-table :headers="showHeaders" :items="desserts"></v-data-table>
    </v-card>
  </v-app>
</div>
</template>

<script>
export default {
 data () {
    return {
      headers: [],
      headersMap: {
        name: { text: 'Dessert (100g serving)', value: 'name' },
        calories: { text: 'Calories', value: 'calories' },
        fat: { text: 'Fat (g)', value: 'fat' },
        carbs: { text: 'Carbs (g)', value: 'carbs' },
        protein: { text: 'Protein (g)', value: 'protein', sortable: false },
        iron: {text: 'Iron (%)', value: 'iron'}
      },
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: '1%',
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: '1%',
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: '7%',
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: '8%',
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: '16%',
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: '0%',
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: '2%',
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: '45%',
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: '22%',
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: '6%',
        },
      ],
      selectedHeaders: []
    }
  },
  created () {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },
  computed: {
    //Done to get the ordered headers
    showHeaders () {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  }
}
</script>
<style scoped>

</style>